import React from 'react';
import { Tooltip, Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { admissionAreaGuide, admissionPolicyGuide } from '../../../config';

// Tooltip content for Khu vực ưu tiên
export const KhuVucTooltipContent = () => (
  <div style={{ maxWidth: 400, maxHeight: 500, overflowY: 'auto' }}>
    <div style={{ fontWeight: 'bold', marginBottom: 10, fontSize: '15px', color: '#fff' }}>
      📍 Hướng dẫn chọn Khu vực ưu tiên
    </div>
    {Object.entries(admissionAreaGuide).map(([code, info], index) => (
      <div 
        key={code} 
        style={{ 
          marginBottom: 10, 
          paddingBottom: 10, 
          borderBottom: index < Object.keys(admissionAreaGuide).length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none'
        }}
      >
        <div style={{ fontWeight: '600', marginBottom: 4, fontSize: '13px', color: '#fbbf24' }}>
          {info.label}
        </div>
        <div style={{ fontSize: '12px', opacity: 0.95, lineHeight: 1.5 }}>
          {info.description}
        </div>
      </div>
    ))}
    <div style={{ 
      marginTop: 12, 
      fontSize: '12px', 
      fontStyle: 'italic', 
      opacity: 0.85,
      padding: '8px',
      backgroundColor: 'rgba(255,255,255,0.1)',
      borderRadius: '4px'
    }}>
      💡 Chọn đúng theo nơi thường trú trên hộ khẩu
    </div>
  </div>
);

// Tooltip content for Đối tượng ưu tiên
export const DoiTuongTooltipContent = () => (
  <div style={{ maxWidth: 450, maxHeight: 500, overflowY: 'auto' }}>
    <div style={{ fontWeight: 'bold', marginBottom: 10, fontSize: '15px', color: '#fff' }}>
      🎯 Hướng dẫn chọn Đối tượng ưu tiên
    </div>
    
    <div style={{ marginBottom: 14 }}>
      <div style={{ 
        fontWeight: '600', 
        marginBottom: 8, 
        color: '#fbbf24',
        fontSize: '13px',
        padding: '4px 8px',
        backgroundColor: 'rgba(251, 191, 36, 0.2)',
        borderRadius: '4px'
      }}>
        {admissionPolicyGuide.group1.title}
      </div>
      {admissionPolicyGuide.group1.items.map((item, index) => (
        <div key={index} style={{ marginBottom: 6, paddingLeft: 10, fontSize: '12px', lineHeight: 1.5 }}>
          • <span style={{ fontWeight: '600', color: '#fcd34d' }}>{item.code}</span> – {item.description}
        </div>
      ))}
    </div>

    <div style={{ marginBottom: 10 }}>
      <div style={{ 
        fontWeight: '600', 
        marginBottom: 8, 
        color: '#93c5fd',
        fontSize: '13px',
        padding: '4px 8px',
        backgroundColor: 'rgba(147, 197, 253, 0.2)',
        borderRadius: '4px'
      }}>
        {admissionPolicyGuide.group2.title}
      </div>
      {admissionPolicyGuide.group2.items.map((item, index) => (
        <div key={index} style={{ marginBottom: 6, paddingLeft: 10, fontSize: '12px', lineHeight: 1.5 }}>
          • <span style={{ fontWeight: '600', color: '#bfdbfe' }}>{item.code}</span> – {item.description}
        </div>
      ))}
    </div>

    <div style={{ 
      marginTop: 12, 
      fontSize: '12px', 
      fontStyle: 'italic', 
      opacity: 0.85,
      padding: '8px',
      backgroundColor: 'rgba(255,255,255,0.1)',
      borderRadius: '4px',
      borderTop: '1px solid rgba(255,255,255,0.15)'
    }}>
      💡 Cần giấy tờ chứng minh. Click vào nút (?) để xem chi tiết đầy đủ.
    </div>
  </div>
);

// Helper button component
export const HelpButton = ({ onClick, title = "Nhấn để xem hướng dẫn" }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      type="text"
      icon={<QuestionCircleOutlined style={{ color: '#1890ff', fontSize: '16px' }} />}
      onClick={handleClick}
      size="small"
      title={title}
      style={{ 
        padding: '0 4px',
        height: 'auto',
        lineHeight: 1
      }}
    />
  );
};
